// import React from "react";

// function Faqs() {
//   const faqs = [
//     {
//       icon: "🎯",
//       question: "How do I win in Heads or Tails?",
//       answer:
//         "You win when the coin lands on the side you selected — either Heads or Tails. The payout is based on your bet and the current multiplier.",
//     },
//     {
//       icon: "💰",
//       question: "What is the minimum and maximum win amount?",
//       answer: (
//         <>
//           The minimum winning amount is{" "}
//           <span className="font-semibold text-cyan-400">1.8×</span> your bet,
//           but depending on the round, you can win up to{" "}
//           <span className="font-semibold text-cyan-400">8×</span> your
//           original stake or even{" "}
//           <span className="font-semibold text-cyan-400">higher</span>!
//         </>
//       ),
//     },
//     {
//       icon: "🔁",
//       question: "Can I play multiple rounds?",
//       answer:
//         "Absolutely! Once a round ends, you can instantly start a new one by placing another bet. Every flip gives you a fresh chance to win!",
//     },
//     {
//       icon: "⚖️",
//       question: "Is the coin flip random?",
//       answer:
//         "Yes — every coin flip is powered by a secure random algorithm, ensuring fair and unbiased outcomes for every round.",
//     },
//     {
//       icon: "⏱️",
//       question: "When can I place my bet?",
//       answer:
//         "You can place your bet before the round timer closes. Once the timer hits zero, betting locks and the coin flip begins!",
//     },
//   ];

//   return (
//     <section className="mt-14 pb-16 px-4 md:px-8 bg-[#0A1221] rounded-2xl shadow-[0_0_25px_rgba(0,224,255,0.1)]">
//       {/* Header */}
//       <div className="flex flex-col items-center mb-10 text-center">
//         <div className="flex items-center gap-2">
//           <span className="text-3xl">💡</span>
//           <h2 className="text-3xl md:text-4xl font-bold tracking-wide text-transparent bg-clip-text bg-gradient-to-r from-[#00e0ff] via-[#00c8ff] to-[#007bff]">
//             Frequently Asked Questions
//           </h2>
//         </div>

//         {/* Glowing underline */}
//         <div className="w-56 h-[3px] mt-3 rounded-full bg-gradient-to-r from-transparent via-[#00e0ff] to-transparent animate-pulse-glow"></div>
//       </div>

//       {/* FAQ List — Always visible */}
//       <div className="space-y-5 max-w-3xl mx-auto">
//         {faqs.map((faq, i) => (
//           <div
//             key={i}
//             className="rounded-xl border border-[#1E2A44] bg-gradient-to-br from-[#0C1221] to-[#101B33] 
//                        hover:shadow-[0_0_20px_rgba(0,224,255,0.25)] transition-all duration-300"
//           >
//             {/* Header + Answer */}
//             <div className="flex items-start gap-3 p-5">
//               <span className="text-xl md:text-2xl">{faq.icon}</span>
//               <div>
//                 <h3 className="font-semibold text-lg md:text-xl text-[#00e0ff] mb-2">
//                   {faq.question}
//                 </h3>
//                 <p className="text-gray-300 text-base leading-relaxed">
//                   {faq.answer}
//                 </p>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Glow animation */}
//       <style>{`
//         @keyframes pulse-glow {
//           0%, 100% {
//             opacity: 0.6;
//             filter: drop-shadow(0 0 6px #00e0ff);
//           }
//           50% {
//             opacity: 1;
//             filter: drop-shadow(0 0 14px #00e0ff);
//           }
//         }
//         .animate-pulse-glow {
//           animation: pulse-glow 2.8s infinite ease-in-out;
//         }
//       `}</style>
//     </section>
//   );
// }

// export default Faqs;


/************************************************************************************************************************** */

import React from "react";
import { HelpCircle } from "lucide-react";

const FAQSection = () => {
  const faqs = [
    {
      question: "How do I play Heads or Tails?",
      answer:
        "Enter your stake, pick Heads or Tails, and confirm. When the round closes, the coin flips — if your side wins, your payout is credited straight to your balance.",
    },
    {
      question: "Can I play without the website?",
      answer:
        "Yes. Dial *464*1# on your phone to play Heads or Tails over USSD anytime — same game, same fair flips.",
    },
    {
      question: "How do I deposit funds?",
      answer:
        "Open Deposit from your wallet, enter the amount in ZMW, and approve the mobile money prompt on your phone (MTN, Airtel, or Zamtel).",
    },
    {
      question: "How do I withdraw my winnings?",
      answer:
        "Open Withdraw in your wallet, enter the amount, and confirm. Cashouts go to your registered mobile money number.",
    },
    {
      question: "Is every flip fair?",
      answer:
        "Yes. Each round uses a secure random outcome so Heads, Tails, and house results stay unbiased and verifiable.",
    },
    {
      question: "What if I disconnect mid-round?",
      answer:
        "Your bet still stands. Reopen the site or dial *464*1# and check your history — the result and payout are already recorded.",
    },
  ];

  return (
    <div className="bg-gray-950 min-h-screen py-16 px-6 text-gray-100 flex flex-col items-center">
      <div className="max-w-3xl w-full space-y-8">
        <h1 className="text-4xl font-bold text-center bg-gradient-to-r from-emerald-400 to-blue-500 bg-clip-text text-transparent mb-4">
          Frequently Asked Questions
        </h1>
        <p className="text-gray-400 text-center mb-8">
          Quick answers for playing Heads or Tails in Zambia — on web or *464*1#.
        </p>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="p-6 rounded-2xl border border-emerald-600/40 bg-gray-900/60 hover:bg-gray-900/80 transition-all shadow-md hover:shadow-emerald-600/10"
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0">
                  <HelpCircle className="text-emerald-400 w-6 h-6 mt-1" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-emerald-300 mb-2">
                    {faq.question}
                  </h3>
                  <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;


//************************************************************************************************************************************************** */
// import { ChevronDown } from "lucide-react";
// import { useState } from "react";

// function Faqs() {
//   const faqs = [
//     {
//       icon: "🎯",
//       question: "How do I win in Heads or Tails?",
//       answer:
//         "You win when the coin lands on the side you selected — either Heads or Tails. The payout is based on your bet and the current multiplier.",
//     },
//     {
//       icon: "💰",
//       question: "What is the minimum and maximum win amount?",
//       answer: (
//         <>
//           The minimum winning amount is{" "}
//           <span className="font-semibold  text-lime-500">1.8×</span> your bet,
//           but depending on the round, you can win up to 8× your original stake
//           or even <span className="font-semibold  text-lime-500">higher</span>!!
//         </>
//       ),
//     },
//     {
//       icon: "🔁",
//       question: "Can I play multiple rounds?",
//       answer:
//         "Yes! Once a round ends, you can instantly start a new one by placing another bet. Every flip gives you a fresh chance to win!",
//     },
//     {
//       icon: "⚖️",
//       question: "Is the coin flip random?",
//       answer:
//         "Absolutely! Each coin flip is powered by a random algorithm, ensuring fair and unbiased outcomes every round.",
//     },
//     {
//       icon: "⏱️",
//       question: "When can I place my bet?",
//       answer:
//         "You can place your bet before the round timer closes. Once the timer hits zero, betting locks and the coin flip begins.",
//     },
//   ];

//   const [openIndex, setOpenIndex] = useState(null);
//   const toggleFaq = (index) => setOpenIndex(openIndex === index ? null : index);

//   return (
//     <div className="mt-12 pb-10">
//       {/* Header with fun underline */}
//       <div className="flex flex-col items-center mb-8 relative">
//         <div className="flex items-center">
//           <span className="text-2xl mr-2">💡</span>
//           <h2
//             className="text-2xl md:text-3xl font-bold tracking-wide 
//             text-transparent bg-gradient-to-r from-[#00e0ff] via-[#00c8ff] to-[#007bff] 
//             bg-clip-text"
//           >
//             Frequently Asked Questions
//           </h2>
//         </div>

//         {/* Underline animation */}
//         <div
//           className="w-48 h-[3px] mt-2 rounded-full bg-gradient-to-r 
//           from-transparent via-[#00e0ff] to-transparent 
//           animate-pulse-glow"
//         ></div>
//       </div>

//       {/* FAQ List */}
//       <div className="space-y-4 mx-4 md:mx-8">
//         {faqs.map((faq, i) => (
//           <div
//             key={i}
//             className={`p-4 rounded-xl border transition-all duration-300 cursor-pointer 
//               ${
//                 openIndex === i
//                   ? "border-[#00e0ff] bg-gradient-to-br from-[#0C1221] to-[#101B33] shadow-[0_0_15px_rgba(0,224,255,0.25)]"
//                   : "border-[#1E2A44] bg-[#111C32] hover:shadow-[0_0_12px_rgba(0,224,255,0.15)]"
//               }`}
//             onClick={() => toggleFaq(i)}
//           >
//             <div className="flex items-center justify-between">
//               <div className="flex items-center gap-2">
//                 <span className="text-lg md:text-xl">{faq.icon}</span>
//                 <h3 className="font-semibold text-[#00e0ff] text-lg">
//                   {faq.question}
//                 </h3>
//               </div>
//               <span
//                 className={`transform transition-transform duration-300 ${
//                   openIndex === i
//                     ? "rotate-180 text-[#00e0ff]"
//                     : "rotate-0 text-gray-400"
//                 }`}
//               >
//                 <ChevronDown />
//               </span>
//             </div>

//             <div
//               className={`overflow-hidden transition-all duration-300 ${
//                 openIndex === i ? "max-h-40 mt-2" : "max-h-0"
//               }`}
//             >
//               <p className="text-gray-300 text-sm md:text-base leading-relaxed">
//                 {faq.answer}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Custom animation for underline */}
//       <style>{`
//         @keyframes pulse-glow {
//           0%, 100% {
//             opacity: 0.6;
//             filter: drop-shadow(0 0 5px #00e0ff);
//           }
//           50% {
//             opacity: 1;
//             filter: drop-shadow(0 0 12px #00e0ff);
//           }
//         }
//         .animate-pulse-glow {
//           animation: pulse-glow 2.5s infinite ease-in-out;
//         }
//       `}</style>
//     </div>
//   );
// }

// export default Faqs;

/************************************************************************************************og-code */

// function Faqs() {
//   const faqs = [
//     {
//       question: "How do I win in Heads or Tails?",
//       answer:
//         "You win when the coin lands on the side you selected — either Heads or Tails. The payout is based on your bet and the current multiplier.",
//     },
//     {
//       question: "What is the minimum and maximum win amount?",
//       answer:
//         "The minimum winning amount is 1.8× your bet, but depending on the round, you can win up to 8× or even 9× your original stake!",
//     },
//     {
//       question: "Can I play multiple rounds?",
//       answer:
//         "Yes! Once a round ends, you can instantly start a new one by placing another bet.",
//     },
//     {
//       question: "Is the coin flip random?",
//       answer:
//         "Absolutely. Each coin flip result is completely random to ensure fair play for all players.",
//     },
//     {
//       question: "When can I place my bet?",
//       answer:
//         "You can place your bet before the round timer closes. Once the timer ends, the coin flip begins and no more bets can be accepted for that round.",
//     },
//   ];
//   return (
//     <>
//       <div className="mt-10">
//         <h2
//           className="text-2xl text-center font-bold pb-3
//           text-transparent bg-gradient-to-r from-[#00ff95] via-[#00e0ff] to-[#007bff]
//           bg-clip-text drop-shadow-[0_0_10px_rgba(0,255,180,0.6)]"
//         >
//           Frequently Asked Questions
//         </h2>

//         <div className="space-y-3 mt-4">
//           {faqs.map((faq, i) => (
//             <div
//               key={i}
//               className="p-4 bg-[#111C32] border border-[#1E2A44] rounded-xl
//                          shadow-[0_0_10px_rgba(0,255,255,0.1)] hover:shadow-[0_0_15px_rgba(0,255,255,0.2)]"
//             >
//               <h3 className="font-semibold text-[#8AF5B3] text-lg">
//                 {faq.question}
//               </h3>
//               <p className="text-gray-300 mt-1">{faq.answer}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// }

// export default Faqs;
